/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useMemo } from "react";

// eslint-disable-next-line node/no-missing-import
import type * as CSS from "csstype";

// Redux-hooks:
import { useAppSelector } from "../../libs/redux-hooks.ts"; // useAppDispatch
// Reducers:
import { getAppState, getTheme } from "../../libs/reducer.ts";
// Types:
import type {TuniversalElementProps} from "../../types/Iuigen.d.ts";

const { rz } = window;

const RZUserStyles:FC<TuniversalElementProps> = ({attributes, children}) => {
  RZUserStyles.displayName = "UserStyles";
  // const theme = useAppSelector(getTheme);
  const {rootAttributes, key, fullPath} = attributes; // onClick, onChange, onRightClick, onHover, onLoad
  const appState = useAppSelector(getAppState(rootAttributes.key)), elState = appState[fullPath];

  const strStyle = useMemo<string>(() => (elState.value || ""), [elState.value]);

  return (<style key={key}>{strStyle}</style>);
}

export default RZUserStyles;
/* eslint-enable @typescript-eslint/no-unused-vars */
